<template>

    <div class="container">

        <app-head title="Manufacturers" />

        <div class="my-4">
            <h1>{{ __('Manufacturers') }}</h1>
        </div>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-5 g-3">

            <div class="col" v-for="manufacturer in manufacturers.data">
                <div class="card h-100">
                    <img class="card-img-top" :src="manufacturer.logo" alt="" v-if="manufacturer.logo" loading="lazy" />
                    <div class="card-body">
                        <h3 class="card-title h6 m-0">
                            <inertia-link :href="manufacturer.permalink" class="stretched-link">
                                {{ manufacturer.short_name || manufacturer.name }}
                            </inertia-link>
                        </h3>
                    </div>
                </div>
            </div>

        </div>

        <pagination :links="manufacturers.meta.links" />

    </div>

</template>

<script>
    import Pagination from '@/shared/Pagination';
    import Breadcrumbs from '@/shared/Breadcrumbs';

    export default {
        props: [
            'manufacturers'
        ],
        data() {
            return {
            }
        },
        components: {
            Pagination,
            Breadcrumbs,
        }
    }
</script>